<template>
  <Modal v-if="open" @hide="close" :width="500">
    <form class="d-f fd-c g m-b m-lg" @submit.prevent="createPlaylist">
      <div class="p-a r-0 t-0 p hover" @click="close">
        <IconBase
          w="15"
          h="15"
          viewBox="0 0 15 15"
          color="#fff"
          icon-name="close"
        >
          <IconCancel />
        </IconBase>
      </div>

      <p class="tt-up ta-c">Edit Playlist</p>

      <input
        type="text"
        name="playlistName"
        id="playlistName"
        ref="playlistNameRef"
        class="border"
        placeholder="Playlist Name"
        v-model="playlistName"
        autocomplete="off"
        @change="savePlaylist"
      />

      <div class="d-f ai-c g border p">
        <p class="flex-1 hover" @click="isPlaylistPrivate = !isPlaylistPrivate">
          Make playlist private
        </p>
        <ToggleSwitch
          name="isPlaylistPrivateInput"
          :value="isPlaylistPrivate"
          @input="setIsPlaylistPrivate"
        />
      </div>

      <div class="d-f g jc-c">
        <p class="link hover tt-up" @click="deletePlaylist">Delete Playlist</p>
      </div>
    </form>
  </Modal>
</template>

<script>
import IconCancel from "@/assets/icons/IconCancel.vue";
import Modal from "@/components/misc/modal.vue";
import IconBase from "@/assets/icons/IconBase.vue";
import ToggleSwitch from "@/components/misc/ToggleSwitch.vue";
import { rtdb } from "@/db";
import _ from "lodash";

export default {
  name: "EditPlaylistModal",
  data() {
    return {
      playlistName: "",
      isPlaylistPrivate: true,
    };
  },
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    playlist: {
      type: Object,
      default: () => null,
    },
  },
  components: { ToggleSwitch, IconBase, Modal, IconCancel },
  methods: {
    setIsPlaylistPrivate(value) {
      this.isPlaylistPrivate = !!value;
      this.savePlaylist();
    },
    savePlaylist() {
      if (!this.playlistRef) {
        return;
      }

      if (!this.playlistName) {
        alert("Please enter a playlist name");
        return;
      }

      const toUpdate = {};
      if (this.playlistName !== this.playlist.title) {
        toUpdate.title = this.playlistName;
      }
      if (this.isPlaylistPrivate !== this.playlist.isPrivate) {
        toUpdate.isPrivate = this.isPlaylistPrivate;
      }

      if (Object.keys(toUpdate).length === 0) {
        return;
      }

      this.playlistRef.update(toUpdate, (error) => {
        if (error) {
          console.error(error);
        }
      });
    },
    deletePlaylist() {
      if (!this.playlistRef) {
        return;
      }

      if (confirm("Delete this playlist?")) {
        this.playlistRef.remove().then(() => {
          this.close();
        });
      }
    },
    close() {
      this.$emit("close");
    },
    playlistNameUpdated: _.debounce((that) => {
      if (!that.playlistName) {
        return;
      }

      that.savePlaylist();
    }, 1000),
  },
  computed: {
    playlistRef() {
      if (!this.playlist) {
        return;
      }

      return rtdb.ref(`playlists/${this.playlist.id}`);
    },
  },
  watch: {
    open() {
      this.playlistName = this.playlist?.title ?? "";
      this.isPlaylistPrivate = this.playlist?.isPrivate ?? true;

      if (this.open) {
        this.$nextTick(() => {
          this.$refs.playlistNameRef?.focus();
        });
      }
    },
    playlistName() {
      this.playlistNameUpdated(this);
    },
  },
};
</script>

<style scoped lang="scss"></style>
